// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_ChecklistResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /implantacao/checklist e POST /implantacao/checklist_salvar — a versão vigente (Full). */
import type { Implantacao_ChecklistEtapaRow } from './Implantacao_ChecklistEtapaRow'
import type { Implantacao_ChecklistItemRow } from './Implantacao_ChecklistItemRow'
import type { Implantacao_VersaoRow } from './Implantacao_VersaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Implantacao_ChecklistResponseDados {
versao: number
etapas: Implantacao_ChecklistEtapaRow[]
itens: Implantacao_ChecklistItemRow[]
versoes: Implantacao_VersaoRow[]
}

export type Implantacao_ChecklistResponse = ApiResponse<Implantacao_ChecklistResponseDados>;

registerResponseContract('Implantacao_ChecklistResponse', {
  versao:  { type: 'number',  required: true },
  etapas: {
    type: 'array',
    required: true,
    items: {
      chave:  { type: 'string',  required: false },
      titulo: { type: 'string',  required: false },
      ordem:  { type: 'number',  required: false },
    },
  },
  itens: {
    type: 'array',
    required: true,
    items: {
      chave:           { type: 'string',  required: false },
      etapa:           { type: 'string',  required: false },
      titulo:          { type: 'string',  required: false },
      descricao:       { type: 'string',  required: false },
      tipo:            { type: 'string',  required: false },
      responsavel:     { type: 'string',  required: false },
      obrigatorio:     { type: 'boolean', required: false },
      automatico:      { type: 'boolean', required: false },
      libera_operacao: { type: 'boolean', required: false },
      travado:         { type: 'boolean', required: false },
    },
  },
  versoes: {
    type: 'array',
    required: true,
    items: {
      versao:     { type: 'number',  required: true },
      criado_por: { type: 'string',  required: false },
      criado_em:  { type: 'string',  required: true },
    },
  },
})
